const AMOUNT_TOKEN = "{amount}";
export {
  AMOUNT_TOKEN
};
